export default __webpack_public_path__ + "static/media/Automation.8351c598.svg";